import ContractorContactDeleteModal from "./ContractorContactDeleteModal";

export default ContractorContactDeleteModal;
